import { SECONDS_IN_A_DAY } from './constants'

export const snapToGrid = (seconds: number): number => {
    const increment = 15 * 60
    return Math.round(seconds / increment) * increment
}

export const enforceMinimumDuration = (from: number, to: number): number => {
    const minDuration = 30 * 60
    return to - from < minDuration ? from + minDuration : to
}

export const formatTime = (seconds: number): string => {
    const SECONDS_IN_AN_HOUR = 3600
    const SECONDS_IN_A_MINUTE = 60

    const totalSecondsInDay = seconds % SECONDS_IN_A_DAY
    const hours = Math.floor(totalSecondsInDay / SECONDS_IN_AN_HOUR)
        .toString()
        .padStart(2, '0')
    const minutes = Math.floor((totalSecondsInDay % SECONDS_IN_AN_HOUR) / SECONDS_IN_A_MINUTE)
        .toString()
        .padStart(2, '0')

    return `${hours}:${minutes}`
}

export const formatTimeRange = (from: number, to: number): string => {
    const isFullDay = to - from === SECONDS_IN_A_DAY && from % SECONDS_IN_A_DAY === 0
    const endTime = isFullDay ? '24:00' : formatTime(to)

    return `${formatTime(from)} - ${endTime}`
}
